<template>
    <div class="imgCot">
        <img v-for="item in 41" v-bind:key="item" :src="getImgUrl(item)" alt="" />
        <div class="exclusive-enjoy">
            <button class="bigBtn default-button" @click="contact">联系专属顾问</button>
        </div>
    </div>
</template>
<script>
    import {callHandler} from "@/utils/bridge";
    import sensors from "sa-sdk-javascript";
    import {sensorsConfig} from "../../../config";
    sensors.init({
        server_url: sensorsConfig.xhjf,
        heatmap: {
            clickmap: "default", //自动采集 $WebClick 事件
            scroll_notice_map: "default", //注意力图 $WebStay事件
        },
        is_track_single_page: true
    });
    sensors.registerPage({
        app_source: '投米'
    });
export default {
    name: "accompanyingService",
    data() {
        return {
        };
    },
    created(){
        sensors.quick("autoTrack");
        sensors.track("TMPeifangEnter");
    },
    mounted() {
    },
    methods: {
        getImgUrl (item) {
            let num = item<10?'0'+item.toString():item;
            return require('@/assets/images/normal/peifang/img_'+ num +'.png');
        },
        contact () {
            // 通知app打开专属顾问页面
            sensors.track("TMPeifangAdviser");
            callHandler('xhToAdviser');
        }
    }
};
</script>

<style lang="less">
.imgCot {
    display: block;
    width: 100%;
    background-size: 100% 100%;
    padding-bottom: 50px;
    img {
        width: 100%;
        display: inherit;
    }
    @media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {
        body {
            padding-top: constant(safe-area-inset-top);
            padding-bottom: constant(safe-area-inset-bottom);
            padding-bottom: env(safe-area-inset-bottom);
        }
    }
}
</style>
